import { IonButton, IonIcon, useIonAlert } from "@ionic/react";
import { pencilOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { setMassiveSignStatus } from "../../../store/documentsSignerList";
import { signDocument } from "../../../store/documentsSignerList/actions/signDocument";
import { selectCheckedDocumentsCount } from "../../../store/documentsSignerList/selectors/selectCheckedDocumentsCount";
import { selectSignerDocuments } from "../../../store/documentsSignerList/selectors/selectSignerDocuments";

export const SignAllButton = () => {
  const dispatch = useDispatch();
  const checkedDocumentsCount = useSelector(selectCheckedDocumentsCount);

  const [present] = useIonAlert();

  const selectedDocuments = useSelector(selectSignerDocuments).filter(({ checked }) => checked);

  const handleSignAll = async () => {
    dispatch(setMassiveSignStatus("pending"));
    for (const document of selectedDocuments) {
      try {
        await dispatch(signDocument(document));
      } catch (error) {
        console.log(error);
      }
    }
    dispatch(setMassiveSignStatus("fulfilled"));
  };

  return (
    <IonButton
      disabled={checkedDocumentsCount === 0}
      fill="solid"
      color="primary"
      class="ion-margin-end"
      onClick={() => {
        present({
          header: `¿Deseas firmar ${checkedDocumentsCount} ${
            checkedDocumentsCount === 1 ? "acuerdo" : "acuerdos"
          } digitalmente?`,
          message: "Al firmar los acuerdos estoy aceptando la veracidad de su contenido.",
          buttons: [
            "No",
            {
              text: `Firmar ${checkedDocumentsCount} ${
                checkedDocumentsCount === 1 ? "acuerdo" : "acuerdos"
              }`,
              handler: () => handleSignAll(),
            },
          ],
        });
      }}
    >
      <IonIcon icon={pencilOutline} slot="start"></IonIcon>
      <span>Firmar ({checkedDocumentsCount})</span>
    </IonButton>
  );
};
